export default __webpack_public_path__ + "static/media/logo-mastercraft.dca2a831.svg";